<template>
  <f7-page name="sucho-v-povrchovych-vodach" @page:init="onPageInit"  @page:beforeout="onPageBeforeOut" @page:beforeremove="onPageBeforeRemove">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Sucho v povrchových vodách</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-toolbar tabbar bottom>
      <f7-link tab-link="#tab-s-mesacne" tab-link-active>Mesačné prietoky</f7-link>
      <f7-link tab-link="#tab-s-denne" >M-denné prietoky</f7-link>
    </f7-toolbar>

    <f7-tabs class="wh-100">
      <f7-tab id="tab-s-mesacne" class="wh-100" @tab:show="onMesacneTabShow($event)" tab-active>
        <f7-block strong class="no-padding no-margin no-border-top position-relative wh-100">

          <div class="svt-dt display-flex" v-if="selectedMonthDt">
            <f7-link popover-open=".datum-mesiace-popover">{{ selectedMonthDt * 1000 | moment('MMMM YYYY') | capitalize }}</f7-link>
            <div><f7-button style="line-height:15px;" icon-size="16" popup-open=".hydro-sucho-mesacne-popup" icon-f7="info_circle" icon-ios="f7:info_circle" icon-aurora="f7:info_circle"></f7-button></div>
          </div>


          <div class="svt-legenda-wrap">
            <img src="static/shmu/img/legenda_mesacne_sucho.png" class="svt-legenda">
          </div>

          <l-map :zoom="zoom"
                 :center="center"
                 :options="mapMonthlyOptions"
                 ref="mapSvtM"
                 class="svt-map"
          >
            <l-control-zoom position="bottomright"  ></l-control-zoom>
            <l-tile-layer
                ref="layerBg"
                :url="url"
                :attribution="attribution"
            />
            <l-tile-layer :url="borderUrl" />
            <l-tile-layer :url="riversUrl" :opacity="0.5" />
            <l-geo-json
                :geojson="svtGeoJsonMonhtlyData"
                :options="svtGeoJsonMonthlyOptions"
            />

            <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
              <div class="leaflet-bar">
                <a @click="geoLocateMapM" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
              </div>
            </l-control>

            <l-control v-if="isGeolocationEnabled && extraParamsM.clearBtnVar" :position="'bottomright'">
              <div class="leaflet-bar">
                <a @click="clearMarkerM" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
              </div>
            </l-control>


          </l-map>


        </f7-block>
      </f7-tab>

      <f7-tab id="tab-s-denne" class="wh-100" @tab:show="onDenneTabShow($event)">
        <f7-block strong class="no-padding no-margin no-border-top position-relative wh-100">

          <div class="svt-dt display-flex" v-if="svtGeoJsonDt">
            <f7-input
                style="width:80px"
                label="Dátum"
                type="datepicker"
                placeholder="Vyberte dátum"
                readonly
                @calendar:change="updateDayDt"
                :value="selectedDayDtF"
                :calendar-params="{locale: 'sk-SK', dateFormat: 'dd.mm.yyyy', closeOnSelect:true, minDate: minDtF, maxDate: maxDtF}"
            ></f7-input>

            <div><f7-button style="line-height:15px;" icon-size="16" popup-open=".hydro-sucho-popup" icon-f7="info_circle" icon-ios="f7:info_circle" icon-aurora="f7:info_circle"></f7-button></div>
          </div>


          <div class="svt-legenda-wrap">
            <img src="static/shmu/img/legenda_mdennost_sucho.png" class="svt-legenda">
          </div>

          <l-map :zoom="zoom"
                 :center="center"
                 :options="mapOptions"
                 ref="mapSvt"
                 class="svt-map"
          >
            <l-control-zoom position="bottomright"  ></l-control-zoom>
            <l-tile-layer
                ref="layerBg"
                :url="url"
                :attribution="attribution"
            />
            <l-tile-layer :url="borderUrl" />
            <l-tile-layer :url="riversUrl" :opacity="0.5" />
            <l-geo-json
                :geojson="svtGeoJsonData"
                :options="svtGeoJsonOptions"
            />

            <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
              <div class="leaflet-bar">
                <a @click="geoLocateMapD" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
              </div>
            </l-control>

            <l-control v-if="isGeolocationEnabled && extraParamsD.clearBtnVar" :position="'bottomright'">
              <div class="leaflet-bar">
                <a @click="clearMarkerD" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
              </div>
            </l-control>

          </l-map>

        </f7-block>
      </f7-tab>
    </f7-tabs>


    <f7-popup class="hydro-sucho-popup">
      <f7-page>
        <f7-navbar title="Hydrologické sucho">
          <f7-nav-right>
            <f7-link popup-close>Zavrieť</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block>
          <strong>Vysvetlenie situácie na vodných tokoch - M-denné prietoky</strong>
          <p>Farebné body na mape predstavujú vodomerné meracie stanice s reprezentáciou M-denného prietoku, dosiahnutého alebo prekročeného po M dní vo zvolenom období.</p>
          <p>Obdobie sa volí spravidla v dĺžke jedného roka. Pri M-denných prietokoch za viacročné obdobie symbol M označuje priemernú dobu (počet dní) dosiahnutia alebo prekročenia príslušného prietoku v roku (STN 75 1410-1).</p>
          <p>V praxi to znamená, že napr. pre 355-denný prietok (Q355d, M=355 dní) platí, že prietok v toku je počas roka v priemere 355 dní rovný alebo väčší než hodnota Q355d.</p>
        </f7-block>
      </f7-page>
    </f7-popup>

    <f7-popup class="hydro-sucho-mesacne-popup">
      <f7-page>
        <f7-navbar title="Hydrologické sucho">
          <f7-nav-right>
            <f7-link popup-close>Zavrieť</f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block>
          <strong>Vysvetlenie situácie na vodných tokoch - mesačné prietoky</strong>
          <p><strong>Qm – priemerný mesačný prietok</strong> sa stanovuje ako aritmetický priemer priemerných denných prietokov za daný mesiac. Udáva sa v m<sup>3</sup>/s.</p>
          <p>V náhľade grafu je Qm reprezentované ako % príslušného dlhodobého priemerného mesačného prietoku za referenčné obdobie 1961-2000.</p>
        </f7-block>
      </f7-page>
    </f7-popup>


    <f7-popover class="datum-mesiace-popover">
      <f7-list>
        <f7-list-item v-for="item in monthList" :key="item.dt"
                      radio :checked="selectedMonthDt === item.dt"
                      :value="item.dt"
                      popover-close
                      name="monthDt"
                      :title="item.title"
                      class="mdt-checkbox"
                      @change="updateMonthDt"
        >
        </f7-list-item>
      </f7-list>
    </f7-popover>



  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import {latLng} from "leaflet";
import {LControlZoom, LControl, LGeoJson, LImageOverlay, LMap, LMarker, LTileLayer} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import shmuMixin from "../js/mixin";
import geoLocationMixin from "../js/geoLocationMixin";

var svt_icn_markers = [];
var svt_icn_markers2 = [];
var svt_icn_m_markers = [];
var svt_icn_m_markers2 = [];




var svt_colors_def = {
  'default':          'rgba(186,186,186,1)',
  'dennost_30plus':   'rgba(42,52,128,1)',
  'dennost_30':       'rgba(0,0,255,1)',
  'dennost_90':       'rgba(113,156,255,1)',
  'dennost_180':      'rgba(153,255,153,1)',
  'dennost_270':      'rgba(230,255,230,1)',
  'dennost_330':      'rgba(255,255,153,1)',
  'dennost_355':      'rgba(255,183,87,1)',
  'dennost_364':      'rgba(255,0,0,1)',


  'vodnost_30plus':   'rgba(42,52,128,1)',
  'vodnost_30':       'rgba(0,132,199,1)',
  'vodnost_90':       'rgba(230,255,230,1)',
  'vodnost_270':      'rgba(255,183,87,1)',
  'vodnost_355':      'rgba(222,82,42,1)',
  'vodnost_364':      'rgba(190,29,44,1)',

  'mes_20':           'rgba(255,0,0,1)',
  'mes_40':           'rgba(255,183,87,1)',
  'mes_60':           'rgba(255,255,153,1)',
  'mes_80':           'rgba(153,255,153,1)',
  'mes_120':          'rgba(102,255,255,1)',
  'mes_160':          'rgba(0,176,240,1)',
  'mes_200':          'rgba(0,112,192,1)',
  'mes_200plus':      'rgba(0,32,96,1)',


}





export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LGeoJson,
    LControlZoom,
    LControl
  },
  mixins: [
    shmuMixin,
    geoLocationMixin
  ],
  data: function () {
    return {
      lastUpdated: 0,
      tCheckInterval: null,
      isGeoJsonLoaded: false,
      svtGeoJsonDt: null,
      selectedMonthDt: null,
      selectedDayDt: null,
      maxMonthDt: null,
      minDt: 1577833200 * 1000, // 2020-01-01
      maxDayDt: null,
      svtGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      svtGeoJsonOptions: {
        onEachFeature:this.openSvtDetailFromFeature,
        pointToLayer: this.makeSvtPoint,
      },

      isGeoJsonMonhtlyLoaded: false,
      svtGeoJsonMonhtlyDt: null,
      svtGeoJsonMonhtlyData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      svtGeoJsonMonthlyOptions: {
        onEachFeature:this.openSvtMonthlyDetailFromFeature,
        pointToLayer: this.makeSvtMonthlyPoint,
      },
      mapTabChanged: 0,
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      mapMonthlyOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      zoom: 6.5,
      center: latLng(48.688714, 19.696843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      riversUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/rieky/v2/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright" class="external">OpenStreetMap</a> contributors',

      // geolocation
      geoLocationMakerD: null,
      geoLocationCircleD: null,
      geoLocationMakerM: null,
      geoLocationCircleM: null,

      showGeolocationClearBtnD: false,
      showGeolocationClearBtnM: false,

      extraParamsD: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      },
      extraParamsM: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      }



    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    monthList() {
      const mm = this.maxMonthDt;
      let res = [];

      if (this.maxMonthDt) {
        let currDate = this.$moment(this.maxMonthDt * 1000).add(-12, 'month');
        let lastDate = this.$moment(this.maxMonthDt * 1000).startOf('month');

        while(currDate.diff(lastDate) <= 0) {

          currDate.add(1, 'month');

          res.push({
            dt: currDate.clone().unix(),
            title: this.$options.filters.capitalize(currDate.clone().format('MMMM YYYY'))
          });
          res.sort((a,b) => (a.dt > b.dt) ? -1 : ((b.dt > a.dt) ? 1 : 0));
        }

        return res;
      }
    },
    minDtF: function() {
      return this.$moment.unix(this.minDt / 1000).toDate();
    },
    maxDtF: function() {
      return this.$moment.unix(this.maxDayDt).toDate();
    },
    selectedDayDtF: function() {
      return [this.$moment.unix(this.selectedDayDt).toDate()];
    }
  },
  watch: {
    mapTabChanged(v) {
      this.$nextTick(() => {
        this.$refs.mapSvt.mapObject.invalidateSize();
        this.$refs.mapSvtM.mapObject.invalidateSize();
      });
    },
    svtGeoJsonMonhtlyData(v) {
      // este nemame naplnene max, je to prvotny load tak extrahujeme maxdt z featuredt
      if (this.maxMonthDt === null) {
        this.maxMonthDt = v.features[0].properties.dt;
      }
      if (this.selectedMonthDt === null) {
        this.selectedMonthDt = v.features[0].properties.dt;
      }

    },
    svtGeoJsonData(v) {
      // este nemame naplnene max, je to prvotny load tak extrahujeme maxdt z featuredt
      if (this.maxDayDt === null) {
        this.maxDayDt = v.features[0].properties.dt;
      }
      if (this.selectedDayDt === null) {
        this.selectedDayDt = v.features[0].properties.dt;
      }

    },
    selectedMonthDt(v) {
      this.loadSvtGeoJsonMonthlyData();
    },
    selectedDayDt(v) {
      this.loadSvtGeoJsonData();
    }

  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-vodne-zdroje');
    this.$f7.accordion.open('.shmu-i-vodne-zdroje');
    this.$nextTick(() => {
      this.initMap();
    });


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) {
        this.loadSvtGeoJsonData();
        this.loadSvtGeoJsonMonthlyData();
      }

    },
    loadSvtGeoJsonData: function() {
      const self = this;

      let cache_dt_key = this.selectedDayDt;
      if (parseInt(this.maxDayDt) === parseInt(this.selectedDayDt)) {
        cache_dt_key = null;
      }

      let cached_geojson = self.$ls.get('hydrodrought_geojson_' + cache_dt_key);
      if (cached_geojson !== null) {
        self.svtGeoJsonData = cached_geojson;
        self.isGeoJsonLoaded = true;
      } else {

        let addon = '';
        if (this.selectedDayDt) {
          addon = '?dt=' + this.selectedDayDt;
        }

        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'hydrodrought/getgeojson' + addon, {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.svtGeoJsonData = response.data;
                self.isGeoJsonLoaded = true;
                self.lastUpdated = self.$moment().unix();
                self.$ls.set('hydrodrought_geojson_' + cache_dt_key, self.svtGeoJsonData, 30 * 60 * 1000); //  30 minut
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 30 * 60 * 1000); // overujem kazdych 5 min

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať údaje o hydrologickom suchu', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }
    },
    loadSvtGeoJsonMonthlyData: function() {
      const self = this;

      let cache_dt_key = this.selectedMonthDt;
      if (parseInt(this.maxMonthDt) === parseInt(this.selectedMonthDt)) {
        cache_dt_key = null;
      }

      let cached_geojson = self.$ls.get('hydrodrought_geojson_monthly_' + cache_dt_key);
      if (cached_geojson !== null) {
        self.svtGeoJsonMonhtlyData = cached_geojson;
        self.isGeoJsonMonhtlyLoaded = true;
      } else {

        self.$f7.dialog.preloader('Načítavam...');
        let addon = '';
        if (this.selectedMonthDt) {
          addon = '?dt=' + this.selectedMonthDt;
        }

        Axios.get(SHMUconf.API_BASE_URL + 'hydrodrought/getgeojsonmonthly' + addon, {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.svtGeoJsonMonhtlyData = response.data;
                self.isGeoJsonMonhtlyLoaded = true;
                self.lastUpdated = self.$moment().unix();
                self.$ls.set('hydrodrought_geojson_monthly_' + cache_dt_key, self.svtGeoJsonMonhtlyData, 30 * 60 * 1000); //  30 minut
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 30 * 60 * 1000); // overujem kazdych 5 min

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať údaje o mesačnom hydrologickom suchu', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }
    },
    initMap() {
      const self = this;
      //this.$refs.mapZrazky.mapObject.ANY_LEAFLET_MAP_METHOD();
      // console.log('leafLet ZRAZKY init done...')

      this.$$('.leaflet-control-attribution a').each((i,item) => {
        self.$$(item).addClass('external')
      });

      this.$refs.mapSvt.mapObject.on('zoomend', function (e) {
        if (this.getZoom() > 9) {
          self.$$('.i-label').css('visibility', 'visible');
        } else {
          self.$$('.i-label').css('visibility', 'hidden');
        }
      });

      this.$refs.mapSvtM.mapObject.on('zoomend', function (e) {
        if (this.getZoom() > 9) {
          self.$$('.i-label').css('visibility', 'visible');
        } else {
          self.$$('.i-label').css('visibility', 'hidden');
        }
      });

      // geolocation
      this.locationMapInitEvents(this, this.$refs.mapSvt.mapObject, this.onLocationFoundD);
      this.locationMapInitEvents(this, this.$refs.mapSvtM.mapObject, this.onLocationFoundM);






    },
    makeSvtPoint(feature, latlng) {
      const self = this;
      let props = feature.properties;
      let width = 1;
      let radius = 6;

      let prop_state = props.prop_state;

      var color = svt_colors_def[prop_state];
      if (color == null) color = 'rgba(0,0,0,1)';
      var custom_text = '';

      let map = this.$refs.mapSvt.mapObject;

      this.svtGeoJsonDt = props.dt;


      if (
          prop_state === 'vodnost_364' ||
          prop_state === 'dennost_364'
      ) {
        custom_text = '!';

        let myIcon2 = L.divIcon({className: 'i-label2', html:custom_text, iconAnchor:[2,9]});
        svt_icn_markers2[feature.id] = L.marker(latlng, {icon: myIcon2}).addTo(map);
        svt_icn_markers2[feature.id]._icon.id = feature.id;
        svt_icn_markers2[feature.id].on({
          click: function (e) {
            self.$f7router.navigate('/situacia-na-vodnych-tokoch/' + e.target._icon.id + '/'+ self.$moment(self.selectedDayDt * 1000).year());

          }
        });


      }



      var  point = L.circleMarker(latlng, {
        radius: radius,
        fillColor: color,
        color: "#000",
        weight: width,
        opacity: 1,
        fillOpacity: 0.9
      });


      let myIcon = L.divIcon({className: 'i-label', html:props.name, iconAnchor:[100,30]});
      svt_icn_markers[feature.id] = L.marker(latlng, {icon: myIcon}).addTo(map);
      svt_icn_markers[feature.id]._icon.id = feature.id;
      svt_icn_markers[feature.id].on({
        click: function (e) {
          let station_id = e.target._icon.id;
          if (station_id && parseInt(station_id) > 0) {
            self.$f7router.navigate('/situacia-na-vodnych-tokoch/' + station_id + '/'+ self.$moment(self.selectedDayDt * 1000).year());
          }
        }
      });



      return point;

    },
    openSvtDetailFromFeature(feature, layer) {
      const self = this;
      layer.on({
        click: function (v) {
          self.$f7router.navigate('/situacia-na-vodnych-tokoch/' + v.target.feature.id  + '/'+ self.$moment(self.selectedDayDt * 1000).year());
        }
      });

    },

    makeSvtMonthlyPoint(feature, latlng) {
      const self = this;
      let props = feature.properties;
      let width = 1;
      let radius = 6;

      let prop_state = props.prop_state;

      var color = svt_colors_def[prop_state];
      if (color == null) color = 'rgba(0,0,0,1)';
      var custom_text = '';

      let map = this.$refs.mapSvtM.mapObject;

      this.svtGeoJsonMonhtlyDt = props.dt;


      if (
          prop_state === 'vodnost_364' ||
          prop_state === 'dennost_364'
      ) {
        custom_text = '!';

        let myIcon2 = L.divIcon({className: 'i-label2', html:custom_text, iconAnchor:[2,9]});
        svt_icn_m_markers2[feature.id] = L.marker(latlng, {icon: myIcon2}).addTo(map);
        svt_icn_m_markers2[feature.id]._icon.id = feature.id;
        svt_icn_m_markers2[feature.id].on({
          click: function (e) {
            self.$f7router.navigate('/situacia-na-vodnych-tokoch-mesacna/' + e.target._icon.id);

          }
        });


      }



      var  point = L.circleMarker(latlng, {
        radius: radius,
        fillColor: color,
        color: "#000",
        weight: width,
        opacity: 1,
        fillOpacity: 0.9
      });


      let myIcon = L.divIcon({className: 'i-label', html:props.name, iconAnchor:[100,30]});
      svt_icn_markers[feature.id] = L.marker(latlng, {icon: myIcon}).addTo(map);
      svt_icn_markers[feature.id]._icon.id = feature.id;
      svt_icn_markers[feature.id].on({
        click: function (e) {
          let station_id = e.target._icon.id;
          if (station_id && parseInt(station_id) > 0) {
            self.$f7router.navigate('/situacia-na-vodnych-tokoch-mesacna/' + station_id + '/'+ self.$moment(self.selectedMonthDt * 1000).year());
          }
        }
      });



      return point;

    },
    openSvtMonthlyDetailFromFeature(feature, layer) {
      const self = this;
      layer.on({
        click: function (v) {
          self.$f7router.navigate('/situacia-na-vodnych-tokoch-mesacna/' + v.target.feature.id+ '/'+ self.$moment(self.selectedMonthDt * 1000).year());
        }
      });

    },

    onMesacneTabShow(e) {
      this.mapTabChanged = Math.random();
    },
    onDenneTabShow(e) {
      this.mapTabChanged = Math.random();
    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) >= 30*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    updateMonthDt(event) {
      const self = this;
      this.selectedMonthDt = event.target.value;
      self.$f7.popover.close();
    },
    updateDayDt(val) {
      let val_ts = this.$moment(val[0]).unix();
      if (this.selectedDayDt !== val_ts) {
        this.selectedDayDt = val_ts;
      }

      /*
      this.selectedMonthDt = event.target.value;
      self.$f7.popover.close();
       */
    },
    onPageBeforeOut() {
      const self = this;
      console.log('onPageBeforeOut');
      // Close opened sheets on page out
      self.$f7.popover.close();
      self.$f7.popup.close();
    },
    onPageBeforeRemove() {
      const self = this;
      //   console.log('onPageBeforeRemove');
      // Destroy sheet modal when page removed
      if (self.popover) self.popover.destroy();
      if (self.popup) self.popup.destroy();
    },

    // geolocation
    geoLocateMapD() {
      this.locationLocate(this, this.$refs.mapSvt.mapObject, 10);
    },
    geoLocateMapM() {
      this.locationLocate(this, this.$refs.mapSvtM.mapObject, 10);
    },

    clearMarkerD() {
      this.locationClearMarker(this, this.$refs.mapSvt.mapObject, this.extraParamsD);
    },
    clearMarkerM() {
      this.locationClearMarker(this, this.$refs.mapSvtM.mapObject, this.extraParamsM);
    },

    onLocationFoundD(e) {
      this.locationFound(this, this.$refs.mapSvt.mapObject, e, this.extraParamsD);
    },
    onLocationFoundM(e) {
      this.locationFound(this, this.$refs.mapSvtM.mapObject, e, this.extraParamsM);
    },

    onLocationError(e) {
      this.locationError(this, e);
    }



  }

};
</script>

<style lang="scss">

/* Landscape phone to landscape tablet */
@media (max-width: 979px) {
  .svt-legenda-wrap {
    z-index: 1100;
    position: absolute;
    top: 0;
    left: 0;
    img {
      max-width: 100%;
      height:auto;
    }
  }
}

/* Small desktop */
@media (min-width: 980px)  {
  .svt-legenda-wrap {
    z-index: 1100;
    position: absolute;
    top: 0;
    left: 50%;

    .svt-legenda {
      position:relative;
      left:-50%;
      max-width: 100%;
      height: auto;
      z-index: 1000;
    }
  }
}

.svt-map {
  width: 100%;
  height: 100%;
}

.i-label2 {
  font-weight: bold;
  color:white;
}

.svt-toolbar {
  text-align: center;
  font-size:0.8em;
  width:100%;
  margin:0;
  padding: 0;
}


.svt-dt {
  height:20px;
  position: absolute;
  bottom: 5px;
  left: 3px;
  background: rgba(255,255,255,0.7);
  color: black;
  padding: 5px 10px;
  border: 1px solid #e2e2e2;
  z-index:1001;
}

.position-relative {
  position: relative;
}


.popover-inner {
  max-height:calc(100vh - 10px) !important;
}
.list-block ul {
  overflow-Y:auto;
}

</style>
